import Vue from 'vue'


import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
// import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
// import './styles/element-variables.scss'


// import Cookies from 'js-cookie'
import Element from 'element-ui'
import VCharts from 'v-charts'


import App from './App'
import router from './router'
import store from './store'
import i18n from './lang' // 国际化


import '@/icons' // icon
import '@/permission' // 权限控制

import VueCoreVideoPlayer from 'vue-core-video-player'

Vue.use(VueCoreVideoPlayer, {
    lang: 'zh-CN'
})


Vue.use(Element, {
    // locale,
    // size: Cookies.get('size') || 'medium', // 设置element-ui默认大小
    i18n: (key, value) => i18n.t(key, value)
})
Vue.use(VCharts)


import websocket from 'vue-native-websocket';
Vue.use(websocket, process.env.BASE_WS, {// 需要连接的服务器地址，端打包后可以填地址（localhost:...）,调试阶段需填写对应开发本地地址(同个局域网，能ping通的地址)或部署的在线服务地址
    reconnection: true, // (Boolean)是否自动重连，默认false
    reconnectionAttempts: 20, // 重连次数
    reconnectionDelay: 3000, // 再次重连等待时常(1000)
});


import Contextmenu from "vue-contextmenujs"
Vue.use(Contextmenu);

// 引入自定义全局css
import '@/assets/css/global.less'
import '@/assets/icon/iconfont.css'


Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    store,
    i18n,
    // template: '<App/>',
    // components: { App }
    render: h => h(App),
    beforeCreate() {
        Vue.prototype.$bus = this;
    }
})



// WEBPACK FOOTER //
// ./src/main.js